/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-05-01 17:01:09
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-07-17 14:55:39
 * @FilePath     : /marketing-landing-fe/src/plugins/Prompt/index.ts
 * @Description  : 未添加文件描述
 */
import { addClass } from '@/utils/dom'; // 插入弹窗

export var appendPrompt = function appendPrompt(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.content,
      content = _c === void 0 ? '' : _c,
      onClose = _a.onClose,
      onMount = _a.onMount,
      _d = _a.closeClass,
      closeClass = _d === void 0 ? 'ui-icon ui-icon-close' : _d;
  var $body = document.body;
  var $content = document.createElement('div');
  var $close = document.createElement('i');
  addClass($content, "ui-prompt ".concat(className));
  addClass($close, closeClass);
  $content.innerHTML = content;
  $content.children[0].appendChild($close);
  $body.appendChild($content);

  $close.onclick = function () {
    if (typeof onClose === 'function') {
      onClose();
    }

    $close.onclick = null;
    $content.onclick = null;
    $body.removeChild($content);
  };

  if (typeof onMount === 'function') {
    onMount($content);
  } // bind($content, $close);

};